import React, { useState } from "react";
import mainStreamLogo from "../assets/mainStream.png";
import { AiOutlineHome } from "react-icons/ai";
import {
  IoPersonCircleOutline,
  IoRefresh,
  IoSettingsOutline,
  IoDocumentText,
} from "react-icons/io5";
import { IoIosAddCircleOutline } from "react-icons/io";
import { RxHamburgerMenu } from "react-icons/rx";
import { CiLogout } from "react-icons/ci";
import { useNavigate } from "react-router-dom"; // Ensure correct import
import Loader from "./reusableComponents/loader";
import { useStores } from "../stores";
import { rolesWithId } from "../constants/constants";
import { FaTable, FaUserFriends } from "react-icons/fa";
import adminAuthService from "../services/authService";

export default function Sidebar({ sideBar, setSideBar }) {
  const [load, setLoad] = useState(false);
  const navigate = useNavigate();
  const { clientsStore } = useStores();

  const handleLogout = () => {
    const confirmation = window.confirm("Are you sure you want to logout?");
    if (!confirmation) return;

    setLoad(true);
    
    // Use JWT authentication service for proper logout
    adminAuthService.logout();
    
    // Clear additional localStorage items
    localStorage.removeItem("user");
    localStorage.removeItem("agents");
    
    // Clear clientsStore user data
    clientsStore.setUserData(null);
    
    // Redirect to login page
    window.location.href = "/login";
  };

  let currentRoute = window.location.pathname.split("/")[2];

  return (
    <>
      {/* Mobile backdrop overlay */}
      {sideBar && window.innerWidth < 768 && (
        <div
          className="fixed inset-0 bg-black bg-opacity-50 z-10 md:hidden"
          onClick={() => setSideBar(false)}
        />
      )}

      {!sideBar && (
        <div
          className="p-2 top-3 left-3 rounded-full z-20 bg-white shadow-lg border border-gray-200 fixed hover:bg-gray-50 cursor-pointer"
          onClick={() => setSideBar(true)}
        >
          <RxHamburgerMenu className="text-gray-600" />
        </div>
      )}

      {sideBar && (
        <div className="fixed left-0 top-0 h-screen w-80 md:w-64 bg-white border-r-2 border-gray-200 flex flex-col justify-between pb-5 z-20 shadow-lg">
          {/* Close button */}
          <div className="absolute top-3 right-3">
            <button
              onClick={() => setSideBar(false)}
              className="p-2 hover:bg-gray-100 rounded-full"
            >
              <RxHamburgerMenu className="text-xl" />
            </button>
          </div>
          {/* Logo */}
          <div className="pt-10 pb-2 px-3">
            <img src={mainStreamLogo} className="w-36" alt="mainStreamLogo" />
          </div>

          {/* Sidebar Navigation Items */}
          <div className="mt-10 flex flex-col text-gray-500 flex-grow">
            <p
              className={`flex px-5 py-2 items-center gap-2 font-semibold cursor-pointer ${
                currentRoute === "all-awakens"
                  ? "bg-blue-200 border-l-4 border-blue-900 text-blue-900"
                  : ""
              }`}
              onClick={() => navigate("/dashboard/all-awakens")}
            >
              <AiOutlineHome className="text-2xl h-7 w-7 " /> DashBoard
            </p>
            {/* Settings available only for superadmin */}
            {clientsStore.user?.role === "6720e9760ca50db671add43c" && (
              <p
                className={`flex px-5 py-2 items-center gap-2 font-semibold cursor-pointer ${
                  currentRoute === "settings"
                    ? "bg-blue-200 border-l-4 border-blue-900 text-blue-900"
                    : ""
                }`}
                onClick={() => navigate("/dashboard/settings")}
              >
                <IoSettingsOutline className="text-2xl h-7 w-7 " /> Settings
              </p>
            )}
            {/* Direct navigation to Fact Finder Clients as a separate section */}
            {(clientsStore.user?.role === rolesWithId.admin || clientsStore.user?.role === rolesWithId.agent) && (
              <p
                className={`flex px-5 py-2 items-center gap-2 font-semibold cursor-pointer ${
                  currentRoute === "fact-finder-clients"
                    ? "bg-blue-200 border-l-4 border-blue-900 text-blue-900"
                    : ""
                }`}
                onClick={() => navigate("/dashboard/fact-finder-clients")}
              >
                <FaUserFriends className="text-2xl h-7 w-7 " /> Fact Finder Clients
              </p>
            )}
            <p
              className={`px-5 py-2 font-semibold ${
                currentRoute === "create-new"
                  ? "bg-blue-200 border-l-4 border-blue-900 text-blue-900"
                  : ""
              } flex items-center whitespace-nowrap gap-2 cursor-pointer`}
              onClick={() => navigate("/dashboard/create-new")}
            >
              <IoIosAddCircleOutline className="text-2xl h-7 w-7 " /> Create New
            </p>
            <p
              className={`flex px-5 py-2 items-center gap-2 font-semibold cursor-pointer ${
                currentRoute === "renewal"
                  ? "bg-blue-200 border-l-4 border-blue-900 text-blue-900"
                  : ""
              }`}
              onClick={() => navigate("/dashboard/renewal")}
            >
              <IoRefresh className="text-2xl h-7 w-7 " /> Renewal
            </p>
            <p
              className={`flex px-5 py-2 items-center gap-2 font-semibold cursor-pointer ${
                currentRoute === "reports"
                  ? "bg-blue-200 border-l-4 border-blue-900 text-blue-900"
                  : ""
              }`}
              onClick={() => navigate("/dashboard/reports")}
            >
              <IoDocumentText className="text-2xl h-7 w-7 " /> Reports
            </p>
            <p
              className={`flex px-5 py-2 items-center gap-2 font-semibold cursor-pointer ${
                currentRoute === "profile"
                  ? "bg-blue-200 border-l-4 border-blue-900 text-blue-900"
                  : ""
              }`}
              onClick={() => navigate("/dashboard/profile")}
            >
              <IoPersonCircleOutline className="text-2xl h-7 w-7 " /> Profile
            </p>
            {clientsStore.user?.role === rolesWithId.admin && (
              <p
                className={`flex px-5 py-2 items-center gap-2 font-semibold cursor-pointer ${
                  currentRoute === "awaken-tables"
                    ? "bg-blue-200 border-l-4 border-blue-900 text-blue-900"
                    : ""
                }`}
                onClick={() => navigate("/dashboard/awaken-tables")}
              >
                <FaTable className="text-2xl h-7 w-7" /> Awaken Tables
              </p>
            )}
          </div>

          {/* Logout Button */}
          <div className="px-5 py-2 text-gray-700 font-semibold">
            <button
              className="flex items-center gap-2 hover:text-red-500"
              onClick={handleLogout}
            >
              <CiLogout className="text-2xl" /> Logout
            </button>
          </div>
        </div>
      )}

      <Loader load={load} />
    </>
  );
}

// import React, { useEffect, useState } from "react";
// import logo from "../assets/logo.png";
// import { AiOutlineHome } from "react-icons/ai";
// import { IoRefresh, IoSettingsOutline } from "react-icons/io5";
// import { IoIosAddCircleOutline } from "react-icons/io";
// import { RxHamburgerMenu } from "react-icons/rx";
// import { CiLogout } from "react-icons/ci";
// import { useNavigate } from "react-router";
// import Loader from "./reusableComponents/loader";

// export default function Sidebar() {
//   const [sideBar, setSideBar] = useState(true);
//   const [load, setLoad] = useState(false);
//   const handleLogout = () => {
//     localStorage.removeItem("user");
//     window.location.reload();
//   }
//   // const [currentRoute, setCurrentRoute] = useState("DashBoard");
//   const navigate = useNavigate();
//   let currentRoute = window.location.pathname.split("/")[2];
//   console.log("currentRoute", currentRoute);
//   return (
//     <>
//       {!sideBar ? (
//         <div
//           className=" p-2 top-3 left-3 rounded-full z-10 bg-white  fixed"
//           onClick={() => setSideBar(true)}
//         >
//           <RxHamburgerMenu />
//         </div>
//       ) : null}
//       {sideBar ? (
//         <div className=" relative h-full  flex flex-col justify-between pb-5 top-0 border-r-2 border-gray-200">
//           <img src={logo} className="pt-12 px-5" alt="logo" />
//           <div className=" text-gray-500">
//             {sideBar ? (
//               <div
//                 className="p-5 absolute right-0"
//                 onClick={() => setSideBar(false)}
//               >
//                 <RxHamburgerMenu className="items-end justify-end" />
//               </div>
//             ) : null}
//           </div>
//           <div className="mt-10 flex flex-col gap-5 text-gray-500">
//             <p
//               className={`flex px-5 items-center gap-2 cursor-pointer ${
//                 currentRoute === "all-awakens"
//                   ? "bg-blue-200 py-2 border-l-4 border-blue-950"
//                   : null
//               }`}
//               onClick={() => navigate("/dashboard/all-awakens")}
//             >
//               <AiOutlineHome className="text-2xl h-7 w-7" /> DashBoard
//             </p>
//             <p className="flex px-5 items-center gap-2">
//               <IoSettingsOutline className="text-2xl h-7 w-7" /> Settings
//             </p>
//             <p
//               className={` px-5  ${
//                 currentRoute === "create-new"
//                   ? "bg-blue-200 py-2 border-l-4 border-blue-950"
//                   : null
//               } flex items-center whitespace-nowrap gap-2 cursor-pointer`}
//               onClick={() => navigate("/dashboard/create-new")}
//             >
//               <IoIosAddCircleOutline className="text-2xl h-7 w-7" /> Create New
//             </p>
//             <p className="flex px-5 items-center gap-2">
//               <IoRefresh className="text-2xl h-7 w-7" /> Renewal
//             </p>
//             <p className="flex px-5 items-center gap-2">
//               <IoRefresh className="text-2xl h-7 w-7" /> Profile
//             </p>
//           </div>
//           <div className="px-1 text-gray-700 mt-auto">
//             <button className="flex items-center gap-2" onClick={() => handleLogout()}>
//               <CiLogout className="text-2xl" /> Logout
//             </button>
//           </div>
//         </div>
//       ) : null}
//       <Loader load={load} />
//     </>
//   );
// }

// import React, { useState } from "react";
// import mainStreamLogo from "../assets/mainStream.png";
// import { AiOutlineHome } from "react-icons/ai";
// import {
//   IoPersonCircleOutline,
//   IoRefresh,
//   IoSettingsOutline,
// } from "react-icons/io5";
// import { IoIosAddCircleOutline } from "react-icons/io";
// import { RxHamburgerMenu } from "react-icons/rx";
// import { CiLogout } from "react-icons/ci";
// import { useNavigate } from "react-router";
// import Loader from "./reusableComponents/loader";

// export default function Sidebar() {
//   const [sideBar, setSideBar] = useState(true);
//   const [load, setLoad] = useState(false);
//   const handleLogout = () => {
// 		// eslint-disable-next-line no-restricted-globals
// 		const confirmation = confirm("Are you sure you want to logout?");
// 		// eslint-disable-next-line no-restricted-globals
// 		if (!confirmation) return;
//     setLoad(true);
// 		localStorage.removeItem("user");
// 		localStorage.removeItem("agents");
// 		window.location.reload();
//     setLoad(false);
// 	};

//   const navigate = useNavigate();
//   let currentRoute = window.location.pathname.split("/")[2];
//   console.log("currentRoute", currentRoute);

//   return (
//     <>
//       {!sideBar ? (
//         <div
//           className="p-2 top-3 left-3 rounded-full z-10 bg-gray-400 fixed"
//           onClick={() => setSideBar(true)}
//         >
//           <RxHamburgerMenu />
//         </div>
//       ) : null}

//       {sideBar ? (
//         <div className="h-[100vh] flex flex-col justify-between pb-5 top-0 border-r-2 border-gray-200">
//           {/* Logo */}
//           <div className="pt-10 pb-2 px-3">
//             <img src={mainStreamLogo} className="w-36" alt="mainStreamLogo" />
//           </div>
//           {/* Sidebar Navigation Items */}
//           <div className="mt-10 flex flex-col text-gray-500 flex-grow">
//             <p
//               className={`flex px-5 py-2 items-center gap-2 font-semibold cursor-pointer ${
//                 currentRoute === "all-awakens"
//                   ? "bg-blue-200 border-l-4 border-blue-900 text-blue-900"
//                   : null
//               }`}
//               onClick={() => navigate("/dashboard/all-awakens")}
//             >
//               <AiOutlineHome className="text-2xl h-7 w-7 " /> DashBoard
//             </p>
//             <p className="flex px-5 py-2 items-center gap-2 font-semibold">
//               <IoSettingsOutline className="text-2xl h-7 w-7 " /> Settings
//             </p>
//             <p
//               className={`px-5 py-2 font-semibold ${
//                 currentRoute === "create-new"
//                   ? "bg-blue-200 border-l-4 border-blue-900  text-blue-900"
//                   : null
//               } flex items-center whitespace-nowrap gap-2 cursor-pointer`}
//               onClick={() => navigate("/dashboard/create-new")}
//             >
//               <IoIosAddCircleOutline className="text-2xl h-7 w-7 " /> Create New
//             </p>
//             <p className="flex px-5 py-2 items-center gap-2 font-semibold">
//               <IoRefresh className="text-2xl h-7 w-7 " /> Renewal
//             </p>
//             <p className="flex px-5 py-2 items-center gap-2 font-semibold">
//               <IoPersonCircleOutline className="text-2xl h-7 w-7 " /> Profile
//             </p>
//           </div>

//           {/* Logout Button */}
//           <div className="px-5 py-2 text-gray-700 font-semibold">
//             <button
//               className="flex items-center gap-2 hover:text-red-500"
//               onClick={() => handleLogout()}
//             >
//               <CiLogout className="text-2xl" /> Logout
//             </button>
//           </div>
//         </div>
//       ) : null}

//       <Loader load={load} />
//     </>
//   );
// }
